module.exports = __webpack_public_path__ + "474e31187fc6430a9835ba47ab88452b.jpg";